import { isObject, isString } from './utils';

// We need to check if localstaorage is available and allowed
// it can be disbaled via config
// but it can also be not available by the browser / react native apps
// therefore we have this ugly wrapper around the localstorage functions
// that checks for the availability and the config
// and then either uses the localstorage or does nothing

// global guard set after config is fetched
function testIfStorageAvailable() {
  let guard = true;
  try {
    guard = window ? true : false;
    guard = window.localStorage ? true : false;
    // @ts-expect-error in case of webview this will fail and error
    guard = window.localStorage.getItem ? true : false;
  } catch {
    // we crash on ios / webview don't use LS
    console.error('crash without window / ls');
    guard = false;
  }
  return guard;
}
const storageAvailable = testIfStorageAvailable();
let allowedByConfig = true;

export const setIsPersitenaceAllowed = (isAllowed: boolean) => {
  allowedByConfig = !!isAllowed;
};

export const isLocalStorageAvailable = () => storageAvailable;
export const isLocalStorageAllowed = () => allowedByConfig;

export const isLocalStorageForbidden = () =>
  !(storageAvailable && allowedByConfig);

export function write(key: string, data: string | object) {
  if (isLocalStorageForbidden()) return;
  if (isObject(data)) {
    window.localStorage.setItem(key, JSON.stringify(data));
    return;
  }
  if (isString(data)) {
    window.localStorage.setItem(key, data as string);
    return;
  }
  // in doubt we just store it as string
  window.localStorage.setItem(key, JSON.stringify(data));
}

export function readAsString(key: string) {
  if (isLocalStorageForbidden()) return null;
  return window.localStorage.getItem(key);
}

export function readAsObject(key: string) {
  if (isLocalStorageForbidden()) return null;
  const data = window.localStorage.getItem(key);
  if (!data) return;
  return JSON.parse(data);
}

export function readAsNumber(key: string) {
  if (isLocalStorageForbidden()) return null;
  const data = window.localStorage.getItem(key);
  if (!data) return;
  return Number(data);
}

export function removeItem(key: string) {
  if (isLocalStorageForbidden()) return null;
  return window.localStorage.removeItem(key);
}

export function removeItems(keys: string[]) {
  if (isLocalStorageForbidden()) return null;
  keys.forEach((element) => {
    window.localStorage.removeItem(element);
  });
}

/* export default this; */
